import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { SIBreadcrumbs } from "app/pages/sales-intelligence/common-components/SIBreadcrumbs/SIBreadcrumbs";
import { SignalsManagementSection } from "app/pages/sales-intelligence/common-components/SignalsManagementSection/SignalsManagementSection";
import manageIntegrationsTrackingService from "app/pages/sales-intelligence/modules/manage-integrations/services/tracking";
import { FIND_NEW_COMPANIES_API_GUIDE_URL } from "app/pages/sales-intelligence/modules/management/sub-modules/constants";
import DataCreditsChip from "app/pages/sales-intelligence/modules/saved-search-webhooks/components/DataCreditsBanner/DataCreditsBanner";
import SavedSearchWebhooksContainer from "app/pages/sales-intelligence/modules/saved-search-webhooks/containers/SavedSearchWebhooksContainer";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { FIND_NEW_COMPANIES_API_BREADCRUMBS } from "../../constants/breadcrumbs";

import {
    StyledBreadcrumbsContainer,
    StyledHeader,
    StyledManagementHeader,
    StyledManagementTabsContainer,
    StyledManagementTitle,
    StyledManagementWrapper,
} from "./styles";

const SavedSearchWebhooksManagementContainer = () => {
    const handleBreadcrumbClick = ({ state }: { state: string }): void => {
        void proNavigator.go(state);
    };

    const breadcrumbs = FIND_NEW_COMPANIES_API_BREADCRUMBS.map((item) => ({ ...item, title: translate(item.title) }));

    const handleGuideClick = (): void => {
        manageIntegrationsTrackingService.trackFindNewCompaniesWebhookGuideClick();
    };

    return (
        <StyledManagementWrapper data-automation="saved-search-webhooks-management-page">
            <StyledBreadcrumbsContainer>
                <SIBreadcrumbs
                    variant="spaceBetween"
                    list={breadcrumbs}
                    onClick={handleBreadcrumbClick}
                    dataAutomation="signals-manage-breadcrumbs"
                >
                    <a
                        href={FIND_NEW_COMPANIES_API_GUIDE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <IconButton
                            iconName="helpcenter"
                            type="flat"
                            data-automation="find-new-companies-webhook-management.guide-button"
                            onClick={handleGuideClick}
                        />
                    </a>
                </SIBreadcrumbs>
            </StyledBreadcrumbsContainer>

            <StyledManagementTabsContainer>
                <StyledHeader>
                    <StyledManagementHeader>
                        <I18n
                            element={StyledManagementTitle}
                            translatable={{ key: "si.management.saved-search-webhooks.page.title" }}
                        />
                    </StyledManagementHeader>
                </StyledHeader>
                <SignalsManagementSection
                    title={translate("si.management.saved-search-webhooks.section.webhook")}
                    subTitle={translate("si.management.saved-search-webhooks.section.webhook.subtitle")}
                    actionButton={<DataCreditsChip />}
                >
                    <SavedSearchWebhooksContainer />
                </SignalsManagementSection>
            </StyledManagementTabsContainer>
        </StyledManagementWrapper>
    );
};

export default SavedSearchWebhooksManagementContainer;
